import { AppUser } from '../app-user.model';

export class StudentGroup {
  students: AppUser[] = [];
  title: string;
  id: number;

  constructor(title: string, id: number, students: AppUser[]) {
    this.title = title;
    this.id = id;

    this.students = students;
  }

  addStudent(student: AppUser) {
    if (this.students.indexOf(student) === -1) this.students.push(student);
  }

  removeStudent(student: AppUser) {
    let index = this.students.indexOf(student);
    if (index > -1) this.students.splice(index, 1);
  }

  hasStudent(student: AppUser) {
    return this.students.indexOf(student) > -1;
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/user/student/student-group.model.ts